import { render, staticRenderFns } from "./policy.vue?vue&type=template&id=7ad97b6f&scoped=true"
import script from "./policy.vue?vue&type=script&lang=js"
export * from "./policy.vue?vue&type=script&lang=js"
import style0 from "./policy.vue?vue&type=style&index=0&id=7ad97b6f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad97b6f",
  null
  
)

export default component.exports